/** True when the value is a real Stripe Checkout Session id (cs_…). */
export function isValidCheckoutSessionId(value: string | null | undefined): value is string {
  if (!value?.trim()) {
    return false;
  }

  const id = value.trim();
  if (id.includes('{') || id.includes('%7B') || /CHECKOUT_SESSION_ID/i.test(id)) {
    return false;
  }

  return /^cs_[a-zA-Z0-9_]+$/.test(id);
}

/** Reads Stripe Checkout session id from the current URL (incl. malformed S3 return links). */
export function readCheckoutSessionIdFromLocation(location: Location = window.location): string | null {
  const url = new URL(location.href);
  const fromQuery = url.searchParams.get('session_id') ?? url.searchParams.get('sessionId');
  if (isValidCheckoutSessionId(fromQuery)) {
    return fromQuery!.trim();
  }

  const decodedPath = decodeURIComponent(`${url.pathname}${url.search}${url.hash}`);
  const fromDecoded = decodedPath.match(/session_id=([^&?#]+)/i)?.[1];
  return isValidCheckoutSessionId(fromDecoded) ? fromDecoded!.trim() : null;
}

export function isCheckoutSuccessPath(pathname: string): boolean {
  const normalized = decodeURIComponent(pathname).replace(/\/+$/, '');
  return normalized === '/checkout/success' || normalized.endsWith('/checkout/success');
}
